import React from "react";
import ConsultationAreaForm from "./ConsultationAreaForm";

const ConsultationArea = () => {
  return (
    <section className="consultation-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="consultation-content">
              <div className="section-title mb-25">
                <img src="/img/icon/consultation_icon01.png" alt="form" />
                <span className="sub-title">95% Accuracy</span>
                <h2 className="title">
                Why You Need a Graphic Design Consultant For Your Business?
                </h2>
              </div>
              <p className="">
              Our consulting services at The Digital Creative Designs Design Agency provide professional graphic design services to help companies overcome obstacles, stimulate creativity, and experience steady development. We offer strategic advice, innovative ideas, and feasible strategies to improve the performance of your company. <br /><br />
              Moreover, our prices are not just reasonable and cheap, but our expert graphic design services add more than just monetary value through commitment and resilience to make your brand a success. Our clear and thorough communication emphasises that our customers do not need to search for graphic designers near me again.
              </p>
              <div className="consultation-list">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <img src="/img/icon/consultation_icon02.png" alt="form" />
                      <span>12x</span>
                    </div>
                    <div className="content">
                      <h6 className="title">Faster Order Processing</h6>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <img src="/img/icon/consultation_icon03.png" alt="form" />
                      <span>95%</span>
                    </div>
                    <div className="content">
                      <h6 className="title">Processing Accuracy</h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <ConsultationAreaForm />
          </div>
        </div>
      </div>

      <div className="consultation-shape-wrap">
        <img
          src="/img/images/consultation_shape01.png"
          alt="form"
          className="shape-one ribbonRotate"
        />
        <img
          src="/img/images/consultation_shape02.png"
          alt="form"
          className="shape-two float-bob-x"
        />
      </div>
    </section>
  );
};

export default ConsultationArea;
